import { getCookie } from 'utils/bom-dom-manipulation/cookies';
import { gamblingLogoURL } from 'utils/constants/casino/gambling-logo-url';
import {
  MATCHTRACKER_LANG,
  STATISTICS_LANG
} from 'utils/constants/languages/language-format';
import { languagePrefixes } from 'utils/constants/swarm/swarm-lang-prefix-constants';
import { GLOBALS } from 'utils/generic/global-variables';
import { isMobile } from 'utils/is-mobile';
import {
  EDateDayMonthOrder,
  EFlagStyle,
  EJurisdiction,
  ESportIconStyle,
  SpringConfigsType
} from 'interfaces/generic';
import {
  EBetCardView,
  EMultiplesView,
  EOlympicLayoutType,
  ETopLeagueLayoutType,
  ETopMatchesLayoutType
} from 'interfaces/sportsbook-configs';
import SpringConfigsDev from '../../dev/spring-configs-dev';

const lang = document.documentElement.lang;
const dir = document.documentElement.dir || 'ltr';
export const androidWrapperApp = getCookie('isAndroidWrapperApp');
export const iOSWrapperApp = getCookie('isIOSWrapperApp');

export const srcEnvVariable =
  process.env.REACT_APP_ENV === 'widgets'
    ? 'REACT_APP_WIDGETS_HOSTING'
    : 'PUBLIC_URL';

export const matchTrakerType = {
  0: 'https://widget-iframe.wadua.io',
  1: 'https://widget-iframe.awidua.io'
};

/* eslint-disable */
/* prettier-ignore */
const SpringConfigs: SpringConfigsType = process.env.NODE_ENV === 'development' ? SpringConfigsDev : {
  PARTNER_ID:                                   GLOBALS.appConfigs.springConfig?.partnerId || 0,
  SOURCE:                                       androidWrapperApp ? 16 : iOSWrapperApp ? 17 : isMobile() ? 4 : 42,
  WRAPPER_APP:                                  !!androidWrapperApp || !!iOSWrapperApp,
  SWARM_URL:                                    GLOBALS.appConfigs.swarmUrl || 'wss://eu-swarm-springre.betconstruct.com/',
  SWARM_BINARY_MESSAGE_ENABLED:                 !!window.swarmBinaryMessageEnabled,
  CASINO_URL:                                   GLOBALS.appConfigs.casinoUrl ||  'https://go.cmsbetconstruct.com/casino',
  DECENTRALIZED_CASINO_URL:                     GLOBALS.appConfigs.decentralizedCasinoUrl ||  '',
  DECENTRALIZED_CASINO_PARTNER_ID:              GLOBALS.appConfigs.decentralizedCasinoPartnerId || 0,
  CMS_URL:                                      GLOBALS.appConfigs.cmsUrl ||  'https://go.cmsbetconstruct.com/',
  JACKPOT_URL:                                  'wss://rgs-wss.betconstructapps.com/jackpot',
  GEO_LINK_URL:                                 GLOBALS.appConfigs.geoLinkUrl || 'https://geoapi.bcapps.net',
  GEO_COMPLY_URL:                               GLOBALS.appConfigs.geoComplyUrl || 'https://cdn.geocomply.com/265/gc-html5.js',
  GEO_COMPLY_ENABLED:                           GLOBALS.appConfigs.geoComplyEnabled || false,
  A_TO_Z_MENU_DATA_PATH:                        GLOBALS.appConfigs.aToZJsonPath || 'https://static.springbuilder.site/fs/userFiles-v2/testvah/data/springXConfigs/aToZNavigationJsonPath.json?v=1632748042',
  ACCOUNT_REGISTRATION_JSON_PATH:               GLOBALS.appConfigs.accountRegistrationJsonPath || '',
  ACCOUNT_PARAMS_COUNTRY_EXCEPTIONS:            GLOBALS.appConfigs.accountParamsCountryExceptions || '',
  SECTIONS_JSON:                                GLOBALS.appConfigs.accountSectionsJsonPath || '',
  ACCOUNT_PARAMS:                               GLOBALS.appConfigs.accountParams || '',
  CUSTOM_PAYMET_URL:                            GLOBALS.appConfigs.customPaymentUrl || '',
  USER_FILES_URL:                               GLOBALS.appConfigs.userFilesUrl || false,
  TERMS_LINK:                                   GLOBALS.appConfigs.termsLink,
  TERMS_POPUP_LINK:                             GLOBALS.appConfigs.termsPopupLink || 'https://www.betconstruct.com',
  PRIVACY_POLICY_LINK:                          GLOBALS.appConfigs.privacyPolicyLink,
  TERMS_LINK_TARGET:                            GLOBALS.appConfigs.termsLinkTarget,
  PRIVACY_POLICY_TARGET:                        GLOBALS.appConfigs.privacyPolicyTarget,
  STORAGE_URL :                                 'https://static.springbuilder.site/',
  LANGUAGE_PREFIX:                              languagePrefixes[lang] || languagePrefixes[lang.slice(0, 2)],
  MATCHTRACKER_LANG_PREFIX:                     MATCHTRACKER_LANG[lang] || MATCHTRACKER_LANG[lang.slice(0, 2)],
  STATISTICS_LANG_PREFIX:                        STATISTICS_LANG[lang] || STATISTICS_LANG[lang.slice(0, 2)],
  CURRENT_LANGUAGE:                             lang || 'en',
  CURRENT_LANGUAGE_PREFIX:                      window.currentLanguagePrefix || 'en',
  DEFAULT_LANGUAGE_PREFIX:                      window.getDefaultLanguagePrefix ? window.getDefaultLanguagePrefix() : window.currentLanguagePrefix || 'en',
  IS_DEFAULT_LANGUAGE:                          GLOBALS.languageConfigs.default,
  ODD_ROUNDING:                                 3,
  PRICE_ROUNDING:                               2,
  PRICE_SEPARATOR:                              GLOBALS.appConfigs.priceSeparator ? ',' : ' ',
  HIDE_TRAILING_ZEROES:                         true,
  VERSION:                                      +(GLOBALS.appConfigs.version || 123456),
  IS_TOP_NAVIGATION_BUTTON_ENABLED:             GLOBALS.appConfigs.isTopNavigationButtonEnabled || false,
  TOP_NAVIGATION_BUTTON_POSITION:               GLOBALS.appConfigs.topNavigationButtonPosition || 'right',
  TOP_NAVIGATION_BUTTON_ALIGNMENT:              GLOBALS.appConfigs.topNavigationButtonAlignment || 'bottom',
  DIRECTION:                                    dir,
  SPORTS_CONFIGS:                               GLOBALS.appConfigs.sportsConfigs || '',
  ERROR_MSG_DURATION:                           GLOBALS.appConfigs.errorMessageDuration || 3,
  IOVATION_MODE:                                GLOBALS.appConfigs.iovationMode || '0',
  SCREENSHOT_TIMEOUT:                           GLOBALS.appConfigs.screenshotTimeout || 2000,
  LOGO_URL:                                     `${GLOBALS.appConfigs.userFilesUrl}/images/logo.png?v=${GLOBALS.appConfigs.translationsVersion || ''}`,
  INCLUDE_SPORT_DATA_IN_META:                   GLOBALS.appConfigs.includeSportDataInMetas,
  SESSION_LIFE_TIME:                            GLOBALS.appConfigs.sessionTime,
  BOTTOM_NAVIGATION:                            GLOBALS.appConfigs.enableBottomNavigation || GLOBALS.appConfigs.bottomNavigation,
  SITE_LOGO_URL:                                GLOBALS.appConfigs.siteLogoUrl || '',
  USER_PERSONALIZATION_ENABLED:                 GLOBALS.appConfigs.userPersonalizationEnabled || false,
  SHOW_BETSLIP_IN_BOTTOM_NAV:                   GLOBALS.appConfigs.bottomNavigationBetslip,
  SEND_PREFERRED_LANGUAGE:                      GLOBALS.appConfigs.sendPreferredLanguage,
  BOTTOM_NAVIGATION_SUB_MENU:                   GLOBALS.appConfigs.bottomNavigationSubMenu,



  /**  CASINO  **/
  CASINO_GAME_SWITCHING_DURING_GAME_SESSION:    true,
  CASINO_GAMES_FETCH_COUNT:                     16,
  CASINO_GAMES_FETCH_MAX_COUNT:                 30,
  CASINO_CACHED_GAMES_MAX_COUNT:                15,
  CASINO_MOBILE_IFRAME:                         Boolean(+(GLOBALS.appConfigs.springConfig?.casinoIFrameMobileOnOff || '0')),
  CASINO_SPORTSBOOK_SWITCHER:                   +(GLOBALS.appConfigs.accountType || 0),
  CASINO_GAMBLING_LOGO_URL:                     GLOBALS.appConfigs.casinoGamblingLogoUrl || gamblingLogoURL,
  CASINO_HIGH_QUALITY_PICTURES:                 GLOBALS.appConfigs.casinoHighQualityPictures || false,
  CASINO_GAME_URL_PREFIX:                       'games',
  CASINO_MOUNT_PATH:                            'slots',
  CASINO_FUN_MODE:                              GLOBALS.appConfigs.casinoFunMode || false,
  CASINO_GAME_SIDEBAR_ENABLED:                  GLOBALS.appConfigs.casinoGameSideBar || false,
  CASINO_PROVIDER_ELEMENT_EXIST:                GLOBALS.appConfigs.casinoProviderElementExist || false,
  CASINO_CATEGORY_ELEMENT_EXIST:                GLOBALS.appConfigs.casinoCategoryElementExist || false,
  CASINO_IFRAME_FROZEN_BALANCE:                 GLOBALS.appConfigs.casinoIframeFrozenBalance || false,
  CASINO_POP_UP_IN_MOBILE:                      GLOBALS.appConfigs.casinoPopUpInMobile || false,
  CASINO_LAUNCH_TYPE:                           GLOBALS.appConfigs.casinoLaunchType || 0,
  CASINO_MULTIVIEW_ENABLED:                     GLOBALS.appConfigs.casinoMultiView || 0,
  HIDE_CASINO_INFO_ICON:                        GLOBALS.appConfigs.hideCasinoInfoIcon || false,


  /**  SPORTSBOOK  **/
  SPORTSBOOK_MOUNT_PATH:              window?.mockedData ? '' : 'match',
  SPORT_MENU_DEFAULT_SELECTED:        GLOBALS.appConfigs.initiallyOpen || 'sportsTypes',
  SPORT_MARKET_IS_COMPACT:            GLOBALS.appConfigs.isCompact || 0,
  SPORT_COMPETITION_IS_COMPACT:       GLOBALS.appConfigs.isCompetitionCompact || 0,
  IS_BOOK_BET_AVAILABLE:              Boolean(+GLOBALS.appConfigs.bookBetAvailable) || false,
  IS_BOOK_BET_MODE_BY_DEFAULT:        Boolean(+GLOBALS.appConfigs.bookingModeByDefault) || false,
  IS_BOOK_BET_SHARING_AVAILABLE:      Boolean(+GLOBALS.appConfigs.bookBetSharingAvailable) || false,
  IS_BOOK_COPY_LINK_AVAILABLE:        Boolean(+GLOBALS.appConfigs.bookCopyLinkAvailable) || false,
  IS_BOOK_FACEBOOK_SHARING_AVAILABLE: Boolean(+GLOBALS.appConfigs.bookFBSharingAvailable) || false,
  IS_BOOK_TELEGRAM_SHARING_AVAILABLE: Boolean(+GLOBALS.appConfigs.bookTelegramSharingAvailable) || false,
  IS_BOOK_TWITTER_SHARING_AVAILABLE:  Boolean(+GLOBALS.appConfigs.bookTwitterSharingAvailable) || false,
  IS_BOOK_WHATSAPP_SHARING_AVAILABLE: Boolean(+GLOBALS.appConfigs.bookingWhatsappAvailable) || false,
  IS_BOOKING_DOWNLOAD_AVAILABLE:      Boolean(+GLOBALS.appConfigs.bookingDownloadingAvailable) || false,
  IS_BET_SHARING_AVAILABLE:           Boolean(+GLOBALS.appConfigs.betSharingAvailable) || false,
  IS_BET_FACEBOOK_SHARING_AVAILABLE:  Boolean(+GLOBALS.appConfigs.betFBSharingAvailable) || false,
  IS_BET_COMMUNTYCHAT_SHARING_AVAILABLE:  Boolean(+GLOBALS.appConfigs.betOccursumSharingAvailable) || false,
  IS_BET_TELEGRAM_SHARING_AVAILABLE:  Boolean(+GLOBALS.appConfigs.betTelegramSharingAvailable) || false,
  IS_BET_TWITTER_SHARING_AVAILABLE:   Boolean(+GLOBALS.appConfigs.betTwitterSharingAvailable) || false,
  IS_BET_WHATSAPP_SHARING_AVAILABLE:  Boolean(+GLOBALS.appConfigs.betWhatsappSharingAvailable) || false,
  IS_BET_DOWNLOAD_AVAILABLE:          Boolean(+GLOBALS.appConfigs.betDownloadingAvailable) || false,
  IS_BET_COPY_LINK_AVAILABLE:         Boolean(+GLOBALS.appConfigs.betCopyLinkAvailable) || false,
  GENERATE_SHARING_IMAGE_URL:         `${window.location.origin}/papi/default/ModuleSbAccount/generateSharingImage`,
  RENDER_COMPETITIONS_IN_DOM:         GLOBALS.appConfigs.renderCompetitionsInDom || false,
  MARKETS_TOOLTIPS:                   GLOBALS.appConfigs.marketsTooltips || false,

  IS_QUICK_BET:                       Boolean(+GLOBALS.appConfigs.quickBet) || false,
  GAME_NUMBER:                        GLOBALS.appConfigs.gameNumber || 0,
  IS_BOOSTED_ODDS_ENABLED:            GLOBALS.appConfigs.boostedOddsEnabled || false,
  PREVIOUS_BOOSTED_ODDS:              GLOBALS.appConfigs.previousBoostedOdds || false,
  IS_MULTIPLES_ENABLED:               GLOBALS.appConfigs.multiplesEnabled || false,
  MULTIPLES_VIEW:                     GLOBALS.appConfigs.expressOfTheDayMobileLayout  || EMultiplesView.EXPANDED,
  IS_EDIT_BET_AVAILABLE:              Boolean(+GLOBALS.appConfigs.editBetAvailable && +GLOBALS.appConfigs.betslipType !== 1) ?? true,
  BETSLIP_ICON:                       GLOBALS.appConfigs.betslipIcon || '',
  IS_BETSLIP_FLOATING_ENABLED:        GLOBALS.appConfigs.betslipFloatingMode,
  IS_BETSLIP_FLOATING_ENABLED_MOBILE: GLOBALS.appConfigs.betslipFloatingModeMobile,
  BETSLIP_FLOATING_PAGES_TYPE:        GLOBALS.appConfigs.betslipFloatingPageType,
  BETSLIP_FLOATING_PAGES:             GLOBALS.appConfigs.betslipFloatingPages || [],
  BETSLIP_FLOATING_PAGES_TYPE_MOBILE: GLOBALS.appConfigs.betslipFloatingPageTypeMobile,
  BETSLIP_FLOATING_PAGES_MOBILE:      GLOBALS.appConfigs.betslipFloatingPagesMobile || [],
  BET_CARD_DEFAULT_VIEW:              GLOBALS.appConfigs.betCardDefaultView || EBetCardView.COMPACT,
  BETSLIP_POSITION:                   GLOBALS.appConfigs.betslipPosition || false,
  TEAM_LOGOS:                         Boolean(+(GLOBALS.appConfigs.teamLogos || '1')),
  TEAM_LOGOS_TYPE:                    GLOBALS.appConfigs.teamLogosType,
  PUSH_NOTIFICATIONS_ENABLED:         GLOBALS.appConfigs.pushNotifications || false,
  BETS_WITH_SAME_GROUP:               !!GLOBALS.appConfigs.betsWithSameGroup,
  BETSLIP_MAX_BTN:                    GLOBALS.appConfigs.betslipMaxBtn || false,
  BETSLIP_MAX_BTN_TYPE:               +(GLOBALS.appConfigs.betslipMaxBtnType || '0'),
  OPEN_BETS_BY_DEFAULT:               GLOBALS.appConfigs.openBetsByDefault || 0,
  BETSLIP_TYPE:                       GLOBALS.appConfigs.betslipType || 0,
  BETSLIP_BASE_UPDATE:                true,
  BET_WITH_ONLY_BONUS_OR_DEPOSIT:     GLOBALS.appConfigs.betWithBonusOrDeposit || false,
  CUSTOM_ICONS:                       GLOBALS.appConfigs.customIcons || false,
  CUSTOM_ICONS_URL:                   GLOBALS.appConfigs.customIconsURL || '',
  SPORT_ICON_STYLE:                   GLOBALS.appConfigs.sportsbookIconStyle || ESportIconStyle.COLORED,
  FLAG_STYLE:                         GLOBALS.appConfigs.flagStyle || EFlagStyle.CIRCLED,
  MATCH_TRACKER_URL:                  matchTrakerType[GLOBALS.appConfigs.matchTrackerType || 0],
  MATCH_TRACKER_TYPE:                 GLOBALS.appConfigs.matchTrackerViewType || 0,
  TOP_LEAGUES:                        Boolean(GLOBALS.appConfigs.topLeagues) || false,
  TOP_LEAGUES_LAYOUT:                 GLOBALS.appConfigs.topLeaguesLayout || ETopLeagueLayoutType.expanded,
  TOP_LEAGUES_DEFAULT_OPEN:           GLOBALS.appConfigs.topLeaguesDefaultOpen || false,
  TOP_MATCHES:                        Boolean(GLOBALS.appConfigs.topMatches) || false,
  TOP_MATCHES_LAYOUT:                 GLOBALS.appConfigs.topMatchesLayout || ETopMatchesLayoutType.expanded,
  OLYMPIC_COMPETITION:                Boolean(GLOBALS.appConfigs.olympicCompetition) || false,
  OLYMPIC_COMPETITION_LAYOUT:         GLOBALS.appConfigs.olympicCompetitionLayout || EOlympicLayoutType.expanded,
  TODAY_EVENTS:                       Boolean(GLOBALS.appConfigs.todayEvents) || false,
  SPORTS_GROUPING:                    GLOBALS.appConfigs.sportsGrouping || 0,
  PERSONALIZED_SPORTS:                GLOBALS.appConfigs.personalizedSports || false,
  LIVE_PREMATCH_SWITCHER:             GLOBALS.appConfigs.includeLivePrematchFilter || false,
  CHAIN_TYPE:                         GLOBALS.appConfigs.chainType || false,
  CALCULATE_POSSIBLE_WIN_WORKER_URL:  window.location.origin + '/widgets-x/workers/calculate-possible-win-worker.js',
  /**  ACCOUNT  **/
  GIFT_BET:                                     GLOBALS.appConfigs.giftBet === '1',
  REBET_AVAILABLE:                              Boolean(+GLOBALS.appConfigs.rebetAvailable === 1),
  IS_PRINT_AVAILABLE:                           Boolean(+GLOBALS.appConfigs.printBetAvailable) && !isMobile() || false,
  REMOVE_SUSPENDED_SELECTION:                   Boolean(+GLOBALS.appConfigs.removeSuspendedSelection) || false,
  METAMASK_LOGIN:                               Boolean(+GLOBALS.appConfigs.metamaskLogin) || false,
  SEON_INTEGRATION:                             GLOBALS.appConfigs.seonIntegration || false,
  SEON_VALIDATION_ACTION:                       GLOBALS.appConfigs.seonValidationAction || 'all',
  THEME_SWITCHER:                               Boolean(GLOBALS.appConfigs.themeMode),
  RESPONSIBLE_GAMING_URL:                       'https://www.opbets.com/responsible-gaming',
  GAMBLING_MESSAGE_URL:                         'http://www.begambleaware.org',
  ACCOUNT_VERIFIED:                             GLOBALS.appConfigs.accountVerification || 0,
  DEPOSIT_PROMO:                                GLOBALS.appConfigs.depositPromo || false,
  ACCOUNT_ELEMENT_EXIST:                        GLOBALS.appConfigs.accountElementExist || false,
  LOW_BALANCE_WARNING_POPUP:                    Boolean(+(GLOBALS.appConfigs.lowBalanceWarningPopup || 0)),


  /**  MISC  **/
  MOCKED_DATA:                                  window?.mockedData || false,
  JURISDICTION:                                 GLOBALS.appConfigs.jurisdiction || EJurisdiction.Default,
  ICON_EXTENSION:                               'svg',
  ICONS_MOUNT_PATH:                             'icon-x',
  IS_WEBP_SUPPORTED:                            null,
  DATE_DAY_MONTH_ORDER:                         GLOBALS.appConfigs.dateDayMonthOrder || EDateDayMonthOrder.dayFirst,
  DT:                                           {
                                                  shortDate:  'DD MMM',
                                                  longDate:   'DD MMM YYYY',
                                                  time:       'HH:mm',
                                                  longTime:   'HH:mm:ss'
                                                },

  PAGE_URLS:                                    GLOBALS.appConfigs.sbPageUrls || {
                                                  live:
                                                            !isMobile()
                                                              ? `${window.location.origin}/desktop-sportsbook-live`
                                                              : `${window.location.origin}/live`,
                                                  prematch:
                                                            !isMobile()
                                                              ? `${window.location.origin}/desktop-sportsbook-prematch`
                                                              : `${window.location.origin}/prematch`,
                                                  casino:       `${window.location.origin}/casino`,
                                                  racing:       `${window.location.origin}/racing`,
                                                  tournaments:  `${window.location.origin}/tournament`,
                                                  esport:       `${window.location.origin}/esports`,
                                                  results:       `${window.location.origin}/results`,
                                                  'live-casino': `${window.location.origin}/live-casino`
                                                },
  FIREBASE_ENABLED:                             Boolean(+GLOBALS.appConfigs.springConfig?.enableFirebase),
  ONE_SIGNAL_APP_ID:                            GLOBALS.appConfigs.springConfig?.oneSignalAppId || '',
  FAST_TRACK_BRAND:                             GLOBALS.appConfigs.springConfig?.fastTrackBrand || '',
  FAST_TRACK_REWARDS:                           GLOBALS.appConfigs.springConfig?.fastTrackRevards || false,

  GAMBLING_AREAS :                              GLOBALS.appConfigs.gamblingAreas,

  NEM_ID_INTEGRATION:                           Number(GLOBALS.appConfigs.nemidIntegration || '0'),
  NEM_ID_INTEGRATION_URL:                       GLOBALS.appConfigs.nemidIntegrationURL || '',


  BET_BUILDER_URL:                              GLOBALS.appConfigs.betBuilderIframeUrl || '',
  COMMUNITY_CHAT_ENABLED:                       GLOBALS.appConfigs.communityChatEnabled || false,
  COMMUNITY_CHAT_USER_VERIFICATION_DISABLED:    GLOBALS.appConfigs.communityChatUserVerificationDisabled || false,
  SENTRY_DISABLED:                              GLOBALS.appConfigs.sentryDisabled || false,
  IS_ACTIVE_STREAM_TAB:                         Boolean(+GLOBALS.appConfigs.isStreamActiveTabCompact) ?? true,
  OUTRIGHT_FILTER:                              +(GLOBALS.appConfigs.outrightFilter || 0),
  CAROUSEL_ARROWS:                              isMobile() ? true : (GLOBALS.appConfigs.carouselArrows || false),
  BET_BUILDER_SWITCHER:                         GLOBALS.appConfigs.betBuilder || false,
  CURRENCIES_WITH_SYMBOLS:                      GLOBALS.appConfigs.currenciesWithSymbols || false,
  CURRENCY_PLACEMENT:                           GLOBALS.appConfigs.currencyPlacement || "default",
  REALITY_CHECK_SWITCHER:                       GLOBALS.appConfigs.realityCheckSwitcher || false,
  DEFAULT_ODD_ACCEPT:                           GLOBALS.appConfigs.defaultOddAccept?.toString() || "2",
  CURRENT_COUNTRY_CODE:                         (GLOBALS.appConfigs.postGridApiKey && Number(GLOBALS.appConfigs.jurisdiction) === 8) ? "CA" : (getCookie('country') as string || getCookie('Country') as string || 'AM'),
  ODD_TYPE:                                     GLOBALS.appConfigs.defaultOddTypes || ["decimal","fractional","american","hongkong","malay","indo"],
  DEFAULT_ODD_TYPE:                             GLOBALS.appConfigs.defaultSelectedOddType || "decimal",
  IS_BET_STATUS_CHECKER_AVAILABLE :             GLOBALS.appConfigs.betStatusCheck || false,
  STATISTICS_SWITCHER:                          Boolean(+(GLOBALS.appConfigs.statisticEnabled || 0)),
  STATISTICS_URL:                               GLOBALS.appConfigs.statisticsLink  || 'https://statistics.betcoapps.com',
  PREDEFINE_STAKES_ENABLE:                      Boolean(+(GLOBALS.appConfigs.betslipPredefinedStakes || '0')),

  PREDEFINE_STAKES_ADDING:                      !!GLOBALS.appConfigs.betslipAddingPredefinedStakes || false,

  PREDEFINE_STAKE_1:                            Number(GLOBALS.appConfigs.stake_1 || ''),
  PREDEFINE_STAKE_2:                            Number(GLOBALS.appConfigs.stake_2 || ''),
  PREDEFINE_STAKE_3:                            Number(GLOBALS.appConfigs.stake_3 || ''),
  DEFAULT_STAKE_ENABLED:                        Boolean(+(GLOBALS.appConfigs.betslipDefaultStake || '0')),
  DEFAULT_STAKE:                                Number(GLOBALS.appConfigs.betslipDefaultStakeValue || ''),
  IS_PARTIAL_CASHOUT_AVAILABLE :                GLOBALS.appConfigs.partial_cashout_off_onn || false,
  IS_ALLOW_BONUS_BALANCE_SUPERBET :             GLOBALS.appConfigs.allow_bonus_balance_for_superbet || false,
  SPORT_TOURNAMENTS:                            GLOBALS.appConfigs.sportTournaments || false,
  ROCKET_BET:                                   GLOBALS.appConfigs.rocketBet || false,
  LVISION:                                      GLOBALS.appConfigs.enableLvision || false,
  LVISION_API_KEY:                              GLOBALS.appConfigs.lvisionAPiKey || '',
  SUPER_BET_DEFAULT_ON:                         GLOBALS.appConfigs.superBetDefaultOn || false,
  PICTURE_IN_PICTURE_STREAMING:                 GLOBALS.appConfigs.pictureInPictureStreaming ?? true,
    AFTER_SUCCESSFUL_BET:                       Number(GLOBALS.appConfigs.afterSuccessfulBet || 0),
    SHOW_MULTIPLE_BET_ORIGINAL_TOTAL_ODDS:      false,


  /** GPS Tracking **/
  GPS_TRACKING_URL :                            window.geolocationUrl || 'https://geolocation.bcapps.net',
  GPS_TRACKING_ENABLED :                        GLOBALS.appConfigs.GPSTrackingEnabled || false,
  GPS_TRACKING_CHECKING_INTERVAL :              GLOBALS.appConfigs.GPSTrackingCheckingInterval || 5000,

  IFRAME_SPORTSBOOK:                            GLOBALS.appConfigs.iframe_sportsbook || false,
  TERMINAL_MODE:                                GLOBALS.appConfigs.terminalMode || false,

  HOMEWORK_ENABLED:                             Boolean(+(GLOBALS.appConfigs.homeworkEnabled || 0)),
  SHOW_SITE_NAME_IN_TITLE:                      Number(GLOBALS.appConfigs.showSiteNameInTitles || 3),
  EXTERNAL_PAYMENT_URL:                         "https://dark-staging-18747819.springbuilder.site",

  /** PostGrid **/
  POSTGRID_API_KEY:                             GLOBALS.appConfigs.postGridApiKey || null,
  POSTGRID_API_URL:                             'https://api.postgrid.com/v1/addver',
  POSTGRID_API_INTERNATIONAL_URL:               'https://api.postgrid.com/v1/intl_addver',

  LOCATE_GBG_API_KEY:                           GLOBALS.appConfigs.locateGBGApiKey || null,

  LEFT_SIDE_BAR:                                GLOBALS.appConfigs.leftSideBar || false,
  LEFT_SIDE_BAR_ALWAYS_OPEN:                    GLOBALS.appConfigs.leftSideBarAlwaysOpen || false,
  LEFT_SIDE_BAR_SPORTS:                         GLOBALS.appConfigs.leftSideSports || false,
  LEFT_SIDE_BAR_CASINO:                         GLOBALS.appConfigs.leftSideCasino || false,
  LEFT_SIDE_BAR_CONFIGS:                        GLOBALS.appConfigs.leftSideBarBannerConfigs,

  IS_RTL:                                       dir === 'rtl',

  COUPON_BUILDER_SWITCHER:                      Boolean(+(GLOBALS.appConfigs.couponBuilder || 0)),
  IOVATION_ENABLED:                             Boolean(+(GLOBALS.appConfigs.iovationEnabledX || 0)),
  HOORY_ENABLED:                                Boolean(+GLOBALS.appConfigs.hooryEnabled) || false,
  HOORY_ENABLED_SPORTSBOOK_BETSLIP:             Boolean(+GLOBALS.appConfigs.hooryForElementsEnabled) || false,
  VERIFY_AGE_POPUP:                             GLOBALS.appConfigs.verifyAgePopup || false,

  DOC_NUMBER_REGISTRATION_AGE_OVER_18:            false,
  DOC_NUMBER_REGISTRATION_PASSPORT_STRICT_FORMAT: false

};
/* eslint-enable */

export default SpringConfigs;
